import React from 'react'

export default function Container({ children, fluid, ...props }) {
    return (
        <div
            {...props}
            css={{
                maxWidth: fluid ? '100%' : 1440,
                width: '100%',
                marginLeft: 'auto',
                marginRight: 'auto',
            }}
        >
            {children}
        </div>
    )
}
